import React, { useState } from "react";
import {
  Col,
  Dialog,
  FabButton,
  Flex,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../../../../pages/style";
import { TbPencil } from "react-icons/tb";
import useLwfService from "./lwf-services";
import { LWF_INITIAL_STATE } from "./lwf-constant";

const AdminLabourWelfareFund = ({ openSnackbar }) => {
  const {
    lwfListinfo,
    setLwf,
    lwf,
    errors,
    setErrors,
    handleBlurFn,
    handleChange,
    handleSubmit,
    handleUpdate,
    allState
  } = useLwfService({ openSnackbar });
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editLwfId, setEditLwfId] = useState(null);

  const handleClickOpen = () => {
    setLwf(LWF_INITIAL_STATE);
    setOpen(true);
    setErrors({});
    setIsEditMode(false);
  };

  const handleEditModalOpen = (data) => {
    setLwf(data);
    setOpen(true);
    setEditLwfId(data?.labour_welfare_fund_id);
    setErrors({});
    setIsEditMode(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLwf(LWF_INITIAL_STATE);
    setErrors({});
  };

  const handleSubmitFn = async () => {
    let success = false;
    if (editLwfId) {
      success = await handleUpdate(editLwfId);
    } else {
      success = await handleSubmit();
    }

    if (!success) {
      setOpen(true);
    } else{
      setOpen(false);
    }
  };


  return (
    <>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Labour Welfare Information
        </Typography>

        <FabButton
          size="sm"
          onClick={() => {
            if (lwfListinfo && lwfListinfo.length > 0) {
              handleEditModalOpen(lwfListinfo[0]);
            } else {
              handleClickOpen()
            }
          }}
          icon={<TbPencil />}
          variant="filled"
          shape="box"
        />
      </Flex>

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            State
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {lwfListinfo[0]?.indian_states?.state_name}
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            {`Employee's`} Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ₹ {lwfListinfo[0]?.employee_contribution?.toFixed(2)}
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            {` Employer's`} Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ₹ {lwfListinfo[0]?.employer_contribution?.toFixed(2)}
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Deduction Cycle
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {lwfListinfo[0]?.deduction_type}
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      {/* labour-welfare */}
      <Dialog
        title={isEditMode ? "Labour Welfare" : "Labour Welfare"}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        bodyScroll={true}
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              label="State"
              name="state"
              options={allState}
              placeholder="Type here..."
              defaultValue={lwf?.state_id}
              valueSinc={!!lwf.state}
              onChange={(val) => handleChange(val, 'state')}
              error={errors.state}
              helperText={errors.state}
              disabled
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Employee's Contribution"
              type="text"
              placeholder="Type Here"
              valueSinc = {!!lwf?.employee_contribution}
              value={lwf?.employee_contribution}
              onChange={(e) => handleChange(e.target.value, "employee_contribution")}
              helperText={errors?.employee_contribution}
              error={errors?.employee_contribution}
              onBlur={(e) => handleBlurFn(e, "employee_contribution")}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Employer's Contribution"
              type="text"
              placeholder="Type Here"
              valueSinc = {!!lwf?.employer_contribution}
              value={lwf?.employer_contribution}
              onChange={(e) => handleChange(e.target.value, "employer_contribution")}
              helperText={errors?.employer_contribution}
              error={errors?.employer_contribution}
              onBlur={(e) => handleBlurFn(e, "employer_contribution")}
            />
          </Col>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Deduction"
              options={[
                { id: "Half Yearly", name: "Half Yearly" },
                { id: "Yearly", name: "Yearly" },
              ]}
              placeholder="Select Here..."
              defaultValue={lwf?.deduction_type}
              onChange={(val) => handleChange(val, "deduction_type")}
              error={errors?.deduction_type}
              helperText={errors?.deduction_type}
              onBlur={(e) => handleBlurFn(e, "deduction_type")}
            />
          </Col>
        </Row>
      </Dialog>

      {/* labour-welfare */}
    </>
  );
};

export default AdminLabourWelfareFund;
